import * as Func from "fp-ts/es6/function"
import * as Ord from "fp-ts/es6/Ord"
import * as Str from "fp-ts/es6/string"
import { Newtype, prism } from "newtype-ts"

export type ActivityId = Newtype<{ readonly ActivityId: unique symbol }, string>
export const stringAsActivityId = prism<ActivityId>(Func.constTrue)
export const activityId: Ord.Ord<ActivityId> = Str.Ord as any
